import clsx from 'clsx';

import { createImgixPlaceholder, CustomNextImage } from '@crehana/next';

import { CompanyCircle, StyledImage } from './Companies.styles';
import { ResponsiveSize } from './types';

type CompaniesRowProps = {
  companies: string[];
  marginRightCn: string;
  containerMtCn: string;
  size: ResponsiveSize;
  margin?: ResponsiveSize;
};

const CompaniesRow: React.FC<CompaniesRowProps> = ({
  containerMtCn,
  companies,
  size,
  margin,
}) => {
  return (
    <div
      className={clsx(
        'flex flex-row justify-center items-center ',
        containerMtCn,
      )}
    >
      {companies.map((logo, i) => (
        <CompanyCircle
          size={size}
          key={`companies-logos-${i}`}
          margin={i + 1 < companies.length ? margin : undefined}
          className="rounded-full shadow-dropdown relative bg-white flex-shrink-0"
        >
          <StyledImage className="relative">
            <CustomNextImage
              src={logo}
              blurDataURL={createImgixPlaceholder(logo)}
              layout="fill"
              alt="Hero background"
              objectFit="contain"
              objectPosition="center"
              placeholder="blur"
            />
          </StyledImage>
        </CompanyCircle>
      ))}
    </div>
  );
};

export default CompaniesRow;
